import Service from "../AuthService";

const Breed = {
  getSettingBreed() {
    return Service.get(`settings/breeds`);
  },
  createSettingBreed(payload, token) {
    return Service.post(`settings/breeds?token=${token}`, payload)
  },
  updateSettingBreed(payload, id, token) {
    return Service.put(`settings/breeds/${id}?token=${token}`, payload)
  },
  deleteSettingBreed(id, token) {
    return Service.delete(`settings/breeds/${id}?token=${token}`)
  },
  getAllBreeds() {
    return Service.get(`breeds`);
  }
};

export default Breed;
